import { RootState } from 'store';

const ClientFormOptionsState = (state: RootState) => state.lookups.clientFormOptions;

export const selectClientFormOptions = (state: RootState) => ClientFormOptionsState(state).rows;
